module.exports = __webpack_public_path__ + "img/icon-8.dc6d80a5.png";